const pendingButtonState = new WeakMap();

const normalizeButtonTargets = (target) => {
    if (!target) {
        return [];
    }
    if (target instanceof Element) {
        return [target];
    }
    if (typeof target.toArray === 'function') {
        return target.toArray();
    }
    if (Array.isArray(target)) {
        return target;
    }
    if (typeof target.length === 'number' && typeof target !== 'string') {
        return Array.from(target);
    }
    return [];
};

export const setButtonPending = (target, isPending, options = {}) => {
    const buttons = normalizeButtonTargets(target).filter((button) => button && typeof button.innerHTML === 'string');

    buttons.forEach((button) => {
        if (isPending) {
            if (pendingButtonState.has(button)) {
                return;
            }

            const rect = button.getBoundingClientRect();
            const state = {
                html: button.innerHTML,
                disabled: Boolean(button.disabled),
                ariaBusy: button.getAttribute('aria-busy'),
                width: button.style.width,
                minWidth: button.style.minWidth,
                height: button.style.height,
                minHeight: button.style.minHeight,
            };
            pendingButtonState.set(button, state);

            if (options.lockSize !== false && rect.width > 0) {
                button.style.width = `${rect.width}px`;
                button.style.minWidth = `${rect.width}px`;
            }
            if (options.lockSize !== false && rect.height > 0) {
                button.style.height = `${rect.height}px`;
                button.style.minHeight = `${rect.height}px`;
            }
            button.disabled = true;
            button.classList.add('ui-button-pending');
            button.setAttribute('aria-busy', 'true');
            button.innerHTML = `
                <span class="ui-button-pending__spinner" aria-hidden="true"></span>
                <span class="visually-hidden">Loading</span>
            `;
            return;
        }

        const state = pendingButtonState.get(button);
        if (!state) {
            return;
        }

        button.innerHTML = state.html;
        button.disabled = state.disabled;
        button.style.width = state.width;
        button.style.minWidth = state.minWidth;
        button.style.height = state.height;
        button.style.minHeight = state.minHeight;
        button.classList.remove('ui-button-pending');
        if (state.ariaBusy === null) {
            button.removeAttribute('aria-busy');
        } else {
            button.setAttribute('aria-busy', state.ariaBusy);
        }
        pendingButtonState.delete(button);
    });
};

export const withButtonPending = async (target, callback, options = {}) => {
    setButtonPending(target, true, options);
    try {
        return await callback();
    } finally {
        setButtonPending(target, false);
    }
};
